import React, { useState } from 'react';

import { Button, Space, Card, Divider, Checkbox } from 'antd';
import { useWizard } from 'components/shared/Wizard';
import { getTranslatedString } from 'helpers/i18n';

function TermsAndConditions({ termsAndConditions, consentText, onClickCancel }) {
  const { nextStep } = useWizard();
  const [agreeTermsAndConditions, setAgreeTermsAndConditions] = useState(false);

  return (
    <Card>
      <div dangerouslySetInnerHTML={{ __html: termsAndConditions }}></div>
      <Checkbox
        checked={agreeTermsAndConditions}
        onChange={(e) => setAgreeTermsAndConditions(e.target.checked)}
      >
        {consentText}
      </Checkbox>

      <Divider />

      <Space>
        <Button disabled={!agreeTermsAndConditions} type="default" onClick={nextStep}>
          {getTranslatedString(
            'tenantPortal.applicationTemplate.termsAndConditions.startApplication'
          )}
        </Button>
        <Button type="default" onClick={onClickCancel}>
          {getTranslatedString('cancel')}
        </Button>
      </Space>
    </Card>
  );
}

export default TermsAndConditions;
